module.exports = __webpack_public_path__ + "static/media/edit-button.0d78f80d.svg";